import { Component } from "preact";
import { connectWithTranslations } from "../../../../common/helpers/translationsHelpers";
import actions from "../../../actions";
import AdvancedFilterTopDesktop from "./AdvancedFilterTopDesktop";
import AdvancedCountryFilterDesktop from "./AdvancedCountryFilterDesktop";
import AdvancedCategoryFilterDesktop from "./AdvancedCategoryFilterDesktop";
import {
    FILTER_TYPE,
    GTM_ID, GA4EVENT,
    SETTING_KEYS,
    TIME_FILTERS_VALUES,
    VOLATILITY_FILTER_OPTIONS,
} from "../../../constants";
import CheckboxPicker from "../../../../common/components/CheckboxPicker";
import { isMobileOnly } from "react-device-detect";
import AdvancedFilterTopMobile from "./AdvancedFilterTopMobile";
import AdvancedCountryFilterMobile from "./AdvancedCountryFilterMobile";
import AdvancedCategoryFilterMobile from "./AdvancedCategoryFilterMobile";
import { getKeysOfNotNullValues } from "../../../../common/helpers/objects";
import DetailModal from "../../modal/DetailModal";
import { getDateRange } from "../../../helpers/filter/dateRange";
import { getSetting } from "../../../../common/helpers/settingStorageHelpers";
import IconSearchSolid from "../../../../common/components/icons/IconSearchSolid";
import { persistSettings } from "../../../../calendar-common/helpers/settingsHelper";
import { getViewDefaultSettings } from "../../../helpers";

class AdvancedFilter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            timezoneOffset: null,
            persistSettings: false,
            volatilities: getKeysOfNotNullValues(VOLATILITY_FILTER_OPTIONS),
            newFilter: {
                eventName: null,
                countries: [],
                categories: [],
                volatilities: [],
                time: null,
                type: null,
            },
        };

        this.loadDefaultSettings = this.loadDefaultSettings.bind(this);
        this.loadCustomSettings = this.loadCustomSettings.bind(this);
        this.applyFilter = this.applyFilter.bind(this);
        this.onImpactChanged = this.onImpactChanged.bind(this);
        this.onChangeCountries = this.onChangeCountries.bind(this);
        this.onChangeEventName = this.onChangeEventName.bind(this);
        this.onChangeCategories = this.onChangeCategories.bind(this);
        this.onChangeTime = this.onChangeTime.bind(this);
    }

    componentWillMount() {
        const { settings } = this.props;
        var newFilter = settings.filter;
        var actualFilterType = settings.actualFilterType;

        if (settings.filter.time === TIME_FILTERS_VALUES.Custom) {
            newFilter.time = TIME_FILTERS_VALUES.RecentNext;
        }

        this.setState({
            newFilter,
            timezoneOffset: settings.timezoneOffset,
            actualFilterType,
        });
    }

    onImpactChanged(values) {
        var vol = values.map((x) => VOLATILITY_FILTER_OPTIONS[x]);
        var newFilter = { ...this.state.newFilter };
        newFilter.volatilities = vol;
        newFilter.type = null;
        this.setState({
            newFilter,
        });
    }

    onChangeCountries(countries) {
        var newFilter = {
            ...this.state.newFilter,
        };
        newFilter.countries = countries;
        newFilter.type = null;
        this.setState({
            newFilter,
        });
    }

    onChangeEventName(eventName) {
        var newFilter = { ...this.state.newFilter };
        newFilter.eventName = eventName;
        newFilter.type = null;
        this.setState({
            newFilter,
        });
    }

    onChangeCategories(categories) {
        var newFilter = {
            ...this.state.newFilter,
        };
        newFilter.categories = categories;
        newFilter.type = null;
        this.setState({
            newFilter,
        });
    }

    onChangeTime({ time }) {
        var dateRange = getDateRange(
            { time },
            this.state.newFilter.timezoneOffset
        );

        var newFilter = { ...this.state.newFilter };
        newFilter.time = time;
        newFilter.dateRange = dateRange;
        newFilter.type = null;

        this.setState({
            newFilter,
        });
    }

    loadDefaultSettings() {
        let nextSettings = getViewDefaultSettings(this.props);

        this.setState({
            newFilter: nextSettings.filter,
            timezoneOffset: nextSettings.timezoneOffset,
            actualFilterType: nextSettings.actualFilterType,
        });
    }

    loadCustomSettings() {
        let customSettings = getSetting(SETTING_KEYS.Settings);
        if (customSettings && customSettings.filter) {
            customSettings.filter.dateRange.to = new Date(
                Date.parse(customSettings.filter.dateRange.to)
            );
            customSettings.filter.dateRange.from = new Date(
                Date.parse(customSettings.filter.dateRange.from)
            );

            this.setState({
                newFilter: customSettings.filter,
                timezoneOffset: customSettings.timezoneOffset,
                actualFilterType: FILTER_TYPE.custom,
            });
        }
    }

    applyFilter() {
        this.state.newFilter.dateRange = getDateRange(
            this.state.newFilter,
            this.state.timezoneOffset
        );

        var settings = this.props.settings;

        if (this.state.persistSettings) {
            settings.filter = this.state.newFilter;
            settings.actualFilterType = FILTER_TYPE.custom;

            persistSettings({ ...settings });
            this.props.filter.type = FILTER_TYPE.custom;
        } else {
            persistSettings({ actualFilterType: this.state.actualFilterType });
        }

        this.props.changeFilter(this.state.newFilter);
        this.props.fetchEventDates();

        if (isMobileOnly) {
            this.props.changeShowMobileFilter(false);
        } else {
            this.props.changeShowAdvancedFilter(false);
        }
    }

    renderDetail() {
        return (
            <div class="fxs_c_advanced-filter">
                <div class="fxs_c_content">
                    <div class="fxs_c_inner">
                        <div class="fxs_clearfix"></div>
                        {isMobileOnly ? (
                            <AdvancedFilterTopMobile
                                filter={this.state.newFilter}
                                time={this.state.newFilter.time}
                                onTimeFilterChanged={(time) =>
                                    this.onChangeTime({ time })
                                }
                                loadDefaultSettings={this.loadDefaultSettings}
                                loadCustomSettings={this.loadCustomSettings}
                                filterType={this.state.newFilter.type}
                            />
                        ) : (
                            <AdvancedFilterTopDesktop
                                filter={this.state.newFilter}
                                time={this.state.newFilter.time}
                                onTimeFilterChanged={(time) =>
                                    this.onChangeTime({ time })
                                }
                                onEventNameChanged={(eventName) =>
                                    this.onChangeEventName(eventName)
                                }
                                loadDefaultSettings={this.loadDefaultSettings}
                                loadCustomSettings={this.loadCustomSettings}
                                filterType={this.state.newFilter.type}
                            />
                        )}

                        <div
                            class={`fxs_clearfix  ${isMobileOnly ? "fxs_c_mobile_filter_main" : ""
                                }`}
                        >
                            {isMobileOnly && (
                                <label class="fxs_c_event-search">
                                    <IconSearchSolid />
                                    <input
                                        type="search"
                                        value={this.state.newFilter.eventName}
                                        onChange={(event) =>
                                            this.onChangeEventName(
                                                event.target.value
                                                    ? event.target.value
                                                    : ""
                                            )
                                        }
                                        placeholder={this.props.translate(
                                            "AdvancedFilterEventNameLabel"
                                        )}
                                        data-gtmid={ this.props.config.tracking && GTM_ID.ADVANCED_FILTERS_EVENT_NAME }
                                        data-ga4event-clk-name={ this.props.config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                                        data-ga4event-element={ this.props.config.tracking && GA4EVENT.ELEMENTS.ADVANCED_FILTERS_EVENT_NAME}
                                    />
                                </label>
                            )}
                            <div class="fxs_c_grid">
                                {isMobileOnly && (
                                    <h4 class="fxs_headline_small fxs_marginBase_top">
                                        {this.props.translate(
                                            "CountryFilterTitle"
                                        )}
                                    </h4>
                                )}
                                {isMobileOnly ? (
                                    <AdvancedCountryFilterMobile
                                        selectedCountries={
                                            this.state.newFilter.countries
                                        }
                                        onChange={(countries) =>
                                            this.onChangeCountries(countries)
                                        }
                                    />
                                ) : (
                                    <AdvancedCountryFilterDesktop
                                        selectedCountries={
                                            this.state.newFilter.countries
                                        }
                                        onChange={(countries) =>
                                            this.onChangeCountries(countries)
                                        }
                                    />
                                )}

                                {isMobileOnly && (
                                    <div class="fxs_clearfix fxs_marginBase_bottom" />
                                )}
                                {!isMobileOnly && <div class="fxs_clearfix" />}
                                {!isMobileOnly && <hr />}
                                {!isMobileOnly && <div class="fxs_clearfix" />}

                                <CheckboxPicker
                                    onChange={(values) =>
                                        this.onImpactChanged(values)
                                    }
                                    values={this.state.volatilities}
                                    checkedValues={getVolatilitiesSelected(
                                        this.state.volatilities,
                                        this.state.newFilter.volatilities
                                    )}
                                    renderTitle={() => (
                                        <h4
                                            class={`${isMobileOnly
                                                ? "fxs_headline_small fxs_marginBase_top"
                                                : "fxs_headline_tiny fxs_marginBase_vertical"
                                                } `}
                                        >
                                            {this.props.translate(
                                                "AdvancedFilterImpactLabel"
                                            )}
                                        </h4>
                                    )}
                                    renderValue={(value) => (
                                        <span>
                                            {" "}
                                            {this.props.translate(value)}{" "}
                                        </span>
                                    )}
                                    getOptionGtmId={(key) =>
                                        this.props.config.tracking &&
                                        GTM_ID.ADVANCED_FILTERS_IMPACT_CHECKBOX(
                                            key
                                                .replace("Volatility_", "")
                                                .toLowerCase()
                                        )
                                    }
                                    getOptionGA4Id={(key) =>
                                        this.props.config.tracking && 
                                        GA4EVENT.ELEMENTS.ADVANCED_FILTERS_IMPACT_CHECKBOX(
                                        key
                                            .replace("Volatility_", "")
                                            .toLowerCase()
                                    ) }
                                    getGa4Name={
                                        this.props.config.tracking &&
                                        GA4EVENT.NAMES.FEATURES_CALENDAR
                                    }                
                                    labelClass="fxs_half fxs_c_filter_picker_label"
                                />

                                {isMobileOnly && (
                                    <div class="fxs_clearfix fxs_marginBase_bottom" />
                                )}
                                {!isMobileOnly && <div class="fxs_clearfix" />}
                                {!isMobileOnly && <hr />}
                                {!isMobileOnly && <div class="fxs_clearfix" />}

                                {isMobileOnly ? (
                                    <AdvancedCategoryFilterMobile
                                        selectedCategories={
                                            this.state.newFilter.categories
                                        }
                                        onChange={(categories) =>
                                            this.onChangeCategories(categories)
                                        }
                                    />
                                ) : (
                                    <AdvancedCategoryFilterDesktop
                                        selectedCategories={
                                            this.state.newFilter.categories
                                        }
                                        onChange={(categories) =>
                                            this.onChangeCategories(categories)
                                        }
                                    />
                                )}
                                <div class="fxs_clearfix" />
                                <hr class="fxs_marginBase_top" />
                                <div class="fxs_c_filter_footer">
                                    <div class="fxs_fLeft">
                                        <label class="fxs_btn fxs_resetMargin fxs_resetPadding">
                                            <input
                                                type="checkbox"
                                                checked={
                                                    this.state.persistSettings
                                                }
                                                data-gtmid={ this.props.config.tracking && GTM_ID.ADVANCED_FILTERS_SAVE_SETTINGS }
                                                data-ga4event-clk-name={ this.props.config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                                                data-ga4event-element={ this.props.config.tracking && GA4EVENT.ELEMENTS.ADVANCED_FILTERS_SAVE_SETTINGS}

                                                onChange={(event) =>
                                                    this.setState({
                                                        persistSettings:
                                                            event.target
                                                                .checked,
                                                    })
                                                }
                                            />
                                            <span>
                                                {" "}
                                                {isMobileOnly
                                                    ? this.props.translate(
                                                        "FilterSaveMobileLabel"
                                                    )
                                                    : this.props.translate(
                                                        "FilterSaveLabel"
                                                    )}{" "}
                                            </span>
                                        </label>
                                    </div>
                                    <div class="fxs_fRight">
                                        <button
                                            type="button"
                                            onClick={this.applyFilter}
                                            class="fxs_btn fxs_btn_cta fxs_resetMargin"
                                            data-gtmid={ this.props.config.tracking && GTM_ID.ADVANCED_FILTERS_APPLY }
                                            data-ga4event-clk-name={ this.props.config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                                            data-ga4event-element={ this.props.config.tracking && GA4EVENT.ELEMENTS.ADVANCED_FILTERS_APPLY}

                                        >
                                            <span>
                                                <span>
                                                    {" "}
                                                    {this.props.translate(
                                                        "FilterApplyLabel"
                                                    )}{" "}
                                                </span>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render({ changeShowMobileFilter }) {
        return isMobileOnly ? (
            <DetailModal
                handleClose={() => {
                    changeShowMobileFilter(false);
                }}
                body={this.renderDetail()}
            ></DetailModal>
        ) : (
            this.renderDetail()
        );
    }
}

const getVolatilitiesSelected = (volatilities, selected) =>
    selected.length === 0
        ? []
        : volatilities.filter((key) =>
            selected.includes(VOLATILITY_FILTER_OPTIONS[key])
        );

export default connectWithTranslations(
    "settings, defaultSettings, basicSettings, config",
    actions
)(AdvancedFilter);
